import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../../components/header";
import ContainerComponent from "../../../components/conatiner";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import InputComponent from "../../../components/input";
import TableComponent from "../../../components/table";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import LoadingComponent from "../../../components/loading";
import { IUser } from "../../../types";
import { UsersManagersDeleteCostCenterService, UsersManagersShowService, UsersMangersAddCostCenterService } from "../../../services/users";
import { ToastErro, ToastSucesso } from "../../../components/toast";
import ModalComponent from "../../../components/modal";
import { FormControl, InputLabel, MenuItem, Select,Grid ,Typography, IconButton} from "@mui/material";

const UsersManagersInfoPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const { id } = useParams();

    const [page, setPage] = useState<number>(1);

    const [user, setUser] = useState<IUser>(null!);
    const [userCostCenters, setUserCostCenters] = useState<any>([]);
    const [costCenters, setCostCenters] = useState<any>([]);

    const [addCostCenter, setAddCostCenter] = useState<number>(null!);

    // função para pesquisar dados da página
    const getData = async () => {

        setLoading(true);

        await UsersManagersShowService(parseInt(id!), page).then(resp => {
            setUser(resp.data.user);
            setUserCostCenters(resp.data.user_cost_centers);
            setCostCenters(resp.data.cost_centers);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar dados da página

    // função para adicionar centro de custo
    const addManagerCostCenter = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if (addCostCenter == null) {
            ToastErro('Selecione um centro de custo!');
            return;
        }

        (window as any).$("#modalAddCostCenter").modal("hide");

        setLoading(true);

        await UsersMangersAddCostCenterService(parseInt(id!), addCostCenter).then(resp => {
            ToastSucesso(resp.data.message);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para adicionar centro de custo

    // função para desativar/ativar acesso ao centro de custo
    const deleteCostCenter = async (id: number) => {

        (window as any).$("#modalDelete" + id).modal("hide");

        setLoading(true);

        await UsersManagersDeleteCostCenterService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para desativar/ativar acesso ao centro de custo

    useEffect(() => {
        getData();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Informações do Usuário"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/users/managers')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Informações Gerais"
                    >
                        {
                            loading

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row">
                                        <InputComponent
                                            label="Nome"
                                            col={12}
                                            size={"small"}
                                            defaultValue={user?.name}
                                            disabled
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="Usuário"
                                            col={6}
                                            size={"small"}
                                            defaultValue={user?.username}
                                            disabled
                                        />
                                        <InputComponent
                                            label="E-mail"
                                            col={6}
                                            size={"small"}
                                            defaultValue={user?.email}
                                            disabled
                                        />
                                    </div>
                                </>
                        }
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Centros de Custo do Usuário"
                        columns={['ID', 'Cod.', 'Centro de Custo', 'Filial','Ativo', 'Desativar/Ativar']}
                        button="Centro de Custo"
                        iconButton={'add'}
                        loading={loading}
                        page={page}
                        last_page={userCostCenters?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                        onClick={() => (window as any).$("#modalAddCostCenter").modal('show')}
                    >
                        {
                            userCostCenters?.data?.map((c: any) => {
                                return (
                                    <tr key={c.id}>
                                        <td className="px-4">{c.id}</td>
                                        <td className="px-4">{c.code}</td>
                                        <td className="px-4">{c.description }</td>
                                        <td className="px-4">{c.branch}</td>
                                        <td className="px-4">
                                            {
                                                c.active == 1

                                                    ?

                                                    <h6><span className="badge bg-success">Sim</span></h6>

                                                    :

                                                    <h6><span className="badge bg-danger">Não</span></h6>
                                            }
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-danger" type="button" title={c.active == 1 ? 'Desativar' : 'Ativar'} onClick={() => (window as any).$("#modalDelete" + c.id).modal('show')}><i className="material-icons">{c.active == 1 ? 'delete' : 'upload'}</i></button>
                                            <ModalComponent
                                                title={c.active == 1 ? 'Desativar Acesso' : 'Ativar Acesso'}
                                                id={`modalDelete${c.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja {c.active == 1 ? 'desativar' : 'ativar'} o acesso do usuário ao centro de custo abaixo?</p>

                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <td>ID:</td>
                                                                <td>{c.id}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Descrição:</td>
                                                                <td>{c.description}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => deleteCostCenter(c.id)}>{c.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>

                    <ModalComponent
                        title="Adicionar Centro de Custo"
                        id="modalAddCostCenter"
                    >
                        <form onSubmit={addManagerCostCenter}>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <FormControl fullWidth>
                                        <InputLabel>Centro de Custo</InputLabel>
                                        <Select
                                            value={addCostCenter}
                                            label="Centro de Custo"
                                            onChange={(e: any) => setAddCostCenter(e.target.value)}
                                            required
                                        >
                                            {
                                                costCenters.map((c: any) => {
                                                    return (
                                                        <MenuItem key={c.id} value={c.id} style={{ padding: '10px 15px' }}>
                                                        <Grid container alignItems="center" spacing={2}>

                                                        <Grid item xs={1}>
                                                                <Typography variant="body2" color="textSecondary">{c.branch}</Typography>
                                                            </Grid>

                                                            <Grid item xs={8}>
                                                                <Typography variant="body1">{c.description}</Typography>
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                <Typography variant="body2" color="primary">{c.code}</Typography>
                                                            </Grid>
                                                         
                                                        </Grid>
                                                    </MenuItem>

                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">Salvar</button>
                            </div>
                        </form>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default UsersManagersInfoPage;